import * as moment from 'moment';
import {FeesRepo} from '../../fees/fees.repo'

class PortfolioManagerExchangeRateController implements angular.IOnInit {

  public toDate ;
  public midRateDate;
  public currentDate;
  public lastTwelveMonths;
  public midRates: Array<any>;

  /** @ngInject */
  constructor(private feesRepo: FeesRepo, private notifyjs) {}

  $onInit() {
    var date = new Date();
    this.currentDate = moment().add(-1, 'days').format('YYYY-MM-DD');
    this.lastTwelveMonths = new Date(moment(date).subtract(18, 'months').endOf('month').format('YYYY-MM-DD'))
    this.midRateDate = this.currentDate;
    this.getMidRateForMonth();
  }


  getMidRateForMonth = () => {
    this.feesRepo.getMidRate(this.midRateDate)
      .then(res => {
        this.midRates = res.data as Array<any>;
      })
      .catch(err => {
        this.notifyjs("Failed to get mid rates for selected month " + err.data)
      })
  }

}
export const portfolioManagerExchangeRates : angular.IComponentOptions = {
  template: require('./portfoliomanagement.exchangerate.html'),
  controller: PortfolioManagerExchangeRateController
};



// WEBPACK FOOTER //
// ./src/app/portfoliomanagement/exchangerates/portfoliomanagement.exchangerate.ts